import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateGoogleWalletProvisionRequest,
  TCreateGoogleWalletProvisionResponse,
} from "./createGoogleWalletProvision.schema";

export const createGoogleWalletProvision = (axios: IAxiosInstance) => {
  return async (
    data: TCreateGoogleWalletProvisionRequest
  ): Promise<IApiResponse<TCreateGoogleWalletProvisionResponse>> => {
    const { paycard_id, ...rest } = data;
    const response = await axios.noRetry.post<
      IApiResponse<TCreateGoogleWalletProvisionResponse>
    >(`/api/paycards/${paycard_id}/google-wallet-provision`, rest);
    return response.data;
  };
};
